
// import React, { useState, useContext, useEffect, useMemo } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaEye,
//   FaEyeSlash,
//   FaEnvelope,
//   FaLock,
//   FaUser,
//   FaPhone,
//   FaBuilding,
//   FaCheckDouble,
//   FaArrowRight,
//   FaGlobe,
// } from "react-icons/fa";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { toast } from "react-toastify";

// // --- Background SMS Animation Component ---
// const BackgroundSMSAnimation = () => {
//   const messages = useMemo(() => Array.from({ length: 18 }).map((_, i) => ({
//     id: i,
//     left: Math.random() * 100,
//     duration: 15 + Math.random() * 15,
//     delay: Math.random() * 10,
//     scale: 0.6 + Math.random() * 0.6,
//     isUser: Math.random() > 0.5,
//     rotation: Math.random() * 10 - 5,
//   })), []);

//   return (
//     <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
//       {messages.map((msg) => (
//         <motion.div
//           key={msg.id}
//           className={`absolute w-64 p-4 rounded-2xl flex flex-col gap-2 backdrop-blur-[2px]
//             ${msg.isUser
//               ? "bg-[#C5F637]/10 border border-[#C5F637]/20 rounded-br-sm"
//               : "bg-white/10 border border-white/10 rounded-bl-sm"
//             }`}
//           initial={{ y: "110vh", opacity: 0 }}
//           animate={{
//             y: "-20vh",
//             opacity: [0, 0.4, 0.4, 0]
//           }}
//           transition={{
//             duration: msg.duration,
//             repeat: Infinity,
//             delay: msg.delay,
//             ease: "linear",
//           }}
//           style={{
//             left: `${msg.left}%`,
//             scale: msg.scale,
//             rotate: `${msg.rotation}deg`
//           }}
//         >
//           <div className={`h-2.5 rounded-full w-3/4 ${msg.isUser ? "bg-[#C5F637]/30" : "bg-white/30"}`} />
//           <div className={`h-2.5 rounded-full w-1/2 ${msg.isUser ? "bg-[#C5F637]/20" : "bg-white/20"}`} />
//           <div className="flex justify-end mt-1 opacity-60">
//             <FaCheckDouble className={`text-xs ${msg.isUser ? "text-[#C5F637]" : "text-white"}`} />
//           </div>
//         </motion.div>
//       ))}
//     </div>
//   );
// };

// const Login = () => {
//   const [user, setUser] = useState({ email: "", password: "" });
//   const [signupUser, setSignupUser] = useState({
//     Firstname: "",
//     Lastname: "",
//     email: "",
//     phone: "",
//     company: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [showSignupPassword, setShowSignupPassword] = useState(false);
//   const [showSignupConfirmPassword, setShowSignupConfirmPassword] = useState(false);
//   const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
//   const [signupMode, setSignupMode] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const [error, setError] = useState("");
//   const [currentSlogan, setCurrentSlogan] = useState(0);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { login } = useContext(AuthContext);

//   const slogans = [
//     { title: "Reach Millions Instantly", desc: "High-throughput Bulk SMS delivery engine." },
//     { title: "Engage. Convert. Grow.", desc: "SMS designed to increase customer impact." },
//     { title: "Global Connectivity", desc: "Direct operator connections across 200+ countries." },
//     { title: "Smart Routing API", desc: "Intelligent fallback logic for guaranteed delivery." },
//   ];

//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const mode = searchParams.get("mode");

//     if (mode === "signup") {
//       setSignupMode(true);
//       navigate("/login", { replace: true });
//     }
//   }, [location, navigate]);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlogan((prev) => (prev + 1) % slogans.length);
//     }, 4000);
//     return () => clearInterval(timer);
//   }, [slogans.length]);

//   const loginUser = async (email, password) => {
//     const response = await fetch(`${API_URL}/api/auth/login`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, password }),
//     });

//     const result = await response.json();
//     if (!response.ok || !result.success) {
//       throw new Error(result.message || "Login failed");
//     }
//     return result;
//   };

//   const goToHomePage = () => {
//     navigate("/");
//   };

//   // --- Unified Submit Logic: All users go to /dashboard ---
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       const response = await loginUser(user.email, user.password);
//       const token = response.data.token;

//       if (rememberMe) {
//         localStorage.setItem("email", user.email);
//         localStorage.setItem("rememberMe", "true");
//       } else {
//         localStorage.removeItem("email");
//         localStorage.removeItem("rememberMe");
//       }

//       // Store token and update context
//       localStorage.setItem("token", token);
//       login(token);

//       toast.success("Login successful!");

//       // Route all users to the same dashboard
//       setTimeout(() => {
//         setLoading(false);
//         navigate("/dashboard");
//       }, 1000);

//     } catch (error) {
//       setError(error.message || "Login failed. Please check your credentials.");
//       setLoading(false);
//       toast.error(error.message);
//     }
//   };

//   const handleForgotPassword = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setTimeout(() => {
//       alert(`Password reset link sent to ${user.email}`);
//       setLoading(false);
//       setForgotPasswordMode(false);
//     }, 500);
//   };

//   const handleSignupSubmit = (e) => {
//     e.preventDefault();
//     console.log("Signup Data: ", signupUser);
//     alert("Signup form submitted! Check console for data.");
//   };

//   useEffect(() => {
//     const savedEmail = localStorage.getItem("email");
//     const savedRememberMe = localStorage.getItem("rememberMe");

//     if (savedEmail && savedRememberMe) {
//       setUser((prev) => ({ ...prev, email: savedEmail }));
//       setRememberMe(true);
//     }
//   }, []);

//   return (
//     <div className="flex justify-center items-center min-h-screen bg-[#0C4550] relative overflow-hidden font-['Roboto',sans-serif]">
//       <style>
//         {`@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap');`}
//       </style>

//       {/* "Go to Website" Button */}
//       <motion.button
//         onClick={goToHomePage}
//         className="absolute top-6 right-6 z-30 flex items-center gap-2 px-4 py-2.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-xl hover:bg-white/20 transition-all duration-300 group"
//         initial={{ opacity: 0, y: -10 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.5 }}
//         whileHover={{ scale: 1.05 }}
//         whileTap={{ scale: 0.95 }}
//       >
//         <FaGlobe className="text-sm" />
//         <span className="text-sm font-medium">Go to Website</span>
//         <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
//       </motion.button>

//       <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20 z-0"></div>
//       <BackgroundSMSAnimation />

//       <motion.div
//         className="relative z-20 w-full max-w-3xl mx-auto px-5 sm:px-6 md:px-10 lg:px-0 flex flex-col md:flex-row backdrop-blur-xl rounded-[20px] overflow-hidden md:border md:border-white/50 md:border-2"
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//       >
//         {/* Left side */}
//         <div className="hidden md:flex md:w-1/2 bg-[#083038] relative p-8 md:p-10 flex-col justify-between overflow-hidden">
//           <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 z-0"></div>

//           <div className="relative z-10">
//             <p className="text-3xl font-extrabold text-white mb-2 tracking-tight">
//               EURO<span className="text-[#C5F637]">FOX</span>
//             </p>
//             <p className="text-[#A7A08F] font-medium tracking-wide text-xs uppercase">Enterprise Communication</p>

//             <div className="mt-12 h-28 relative">
//               <AnimatePresence mode="wait">
//                 <motion.div
//                   key={currentSlogan}
//                   initial={{ opacity: 0, x: 20 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   exit={{ opacity: 0, x: -20 }}
//                   transition={{ duration: 0.5, ease: "easeInOut" }}
//                   className="absolute inset-0 flex flex-col justify-center"
//                 >
//                   <h3 className="text-2xl font-bold text-white leading-tight mb-2">
//                     {slogans[currentSlogan].title}
//                   </h3>
//                   <p className="text-gray-300 text-sm leading-relaxed border-l-3 border-[#C5F637] pl-3">
//                     {slogans[currentSlogan].desc}
//                   </p>
//                 </motion.div>
//               </AnimatePresence>
//             </div>

//             <div className="flex gap-2 mt-6">
//               {slogans.map((_, index) => (
//                 <div
//                   key={index}
//                   className={`h-1 rounded-full transition-all duration-300 ${index === currentSlogan ? "w-6 bg-[#C5F637]" : "w-2 bg-white/20"}`}
//                 ></div>
//               ))}
//             </div>
//           </div>

//           <div className="relative z-10">
//             <p className="text-white/40 text-xs mt-4">Trusted by 10,000+ Enterprises Worldwide</p>
//           </div>
//           <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-[#C5F637] rounded-full opacity-10 blur-2xl"></div>
//         </div>

//         {/* Right Side: Form */}
//         <div className="w-full md:w-1/2 px-5 py-5 md:p-10 bg-white flex md:rounded-[1px] rounded-[10px] flex-col justify-center">
//           <div className="text-left mb-6">
//             <p className="text-2xl font-bold text-[#0C4550] mb-2">
//               {signupMode ? "Create Account" : forgotPasswordMode ? "Reset Password" : "Welcome Back"}
//             </p>
//             <p className="text-gray-700 text-sm">
//               {signupMode ? "Start your 14-day free trial" : forgotPasswordMode ? "We'll email you instructions" : "Please enter your details to sign in"}
//             </p>
//           </div>

//           {error && !signupMode && (
//             <div className="mb-5 p-3 bg-red-50 border border-red-100 text-red-600 rounded-lg text-sm flex items-center gap-2 animate-pulse">
//               <div className="w-1.5 h-1.5 bg-red-500 rounded-full"></div>
//               {error}
//             </div>
//           )}

//           <form onSubmit={signupMode ? handleSignupSubmit : forgotPasswordMode ? handleForgotPassword : handleSubmit}>
//             {signupMode ? (
//               <div className="grid grid-cols-2 gap-3">
//                 <InputField icon={FaUser} type="text" placeholder="First Name" value={signupUser.Firstname} onChange={(e) => setSignupUser({ ...signupUser, Firstname: e.target.value })} />
//                 <InputField icon={FaUser} type="text" placeholder="Last Name" value={signupUser.Lastname} onChange={(e) => setSignupUser({ ...signupUser, Lastname: e.target.value })} />
//                 <InputField icon={FaEnvelope} type="email" placeholder="Email" className="col-span-2" value={signupUser.email} onChange={(e) => setSignupUser({ ...signupUser, email: e.target.value })} />
//                 <InputField icon={FaPhone} type="text" placeholder="Phone" value={signupUser.phone} onChange={(e) => setSignupUser({ ...signupUser, phone: e.target.value })} />
//                 <InputField icon={FaBuilding} type="text" placeholder="Company" value={signupUser.company} onChange={(e) => setSignupUser({ ...signupUser, company: e.target.value })} />
//                 <PasswordField placeholder="Password" value={signupUser.password} onChange={(e) => setSignupUser({ ...signupUser, password: e.target.value })} show={showSignupPassword} onToggle={() => setShowSignupPassword(!showSignupPassword)} />
//                 <PasswordField placeholder="Confirm" value={signupUser.confirmPassword} onChange={(e) => setSignupUser({ ...signupUser, confirmPassword: e.target.value })} show={showSignupConfirmPassword} onToggle={() => setShowSignupConfirmPassword(!showSignupConfirmPassword)} />
//               </div>
//             ) : (
//               <div className="space-y-4">
//                 <InputField icon={FaEnvelope} type="email" placeholder="Email Address" value={user.email} onChange={(e) => setUser({ ...user, email: e.target.value })} />
//                 {!forgotPasswordMode && (
//                   <PasswordField placeholder="Password" value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} show={showPassword} onToggle={() => setShowPassword(!showPassword)} />
//                 )}
//               </div>
//             )}

//             {!forgotPasswordMode && !signupMode && (
//               <div className="flex items-center justify-between mt-4">
//                 <label className="flex items-center text-sm text-gray-800 font-base cursor-pointer transition-colors">
//                   <input type="checkbox" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} className="mr-2 accent-[#0C4550]" />
//                   Remember me
//                 </label>
//                 <button type="button" className="text-sm font-base text-gray-800 transition-colors" onClick={() => setForgotPasswordMode(true)}>
//                   Forgot password?
//                 </button>
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full mt-6 py-3 bg-[#0C4550] text-white rounded-xl font-bold shadow-lg shadow-[#0C4550]/20 hover:bg-[#09353e] transition-all duration-300 transform hover:-translate-y-0.5 active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center gap-2"
//             >
//               {loading ? (
//                 <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
//               ) : (
//                 signupMode ? "Create Account" : forgotPasswordMode ? "Send Reset Link" : "Sign In"
//               )}
//             </button>
//           </form>

//           <div className="mt-6 text-center text-sm">
//             {forgotPasswordMode ? (
//               <p className="text-gray-700">Remembered? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setForgotPasswordMode(false)}>Login</button></p>
//             ) : !signupMode ? (
//               <p className="text-gray-700">Don't have an account? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setSignupMode(true)}>Sign up</button></p>
//             ) : (
//               <p className="text-gray-700">Already have an account? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setSignupMode(false)}>Login</button></p>
//             )}
//           </div>

//           <div className="mt-5 pt-5 border-t border-gray-100">
//             <button
//               onClick={goToHomePage}
//               className="w-full flex items-center justify-center gap-2 py-2.5 text-gray-800 font-medium hover:bg-gray-50 rounded-lg transition-all group"
//             >
//               <span className="text-sm">Explore Our Website</span>
//               <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
//             </button>
//           </div>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// const InputField = ({ icon: Icon, className = "", ...props }) => (
//   <div className={`relative group ${className}`}>
//     <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] group-focus-within:text-[#0C4550] transition-colors text-sm" />
//     <input {...props} className="w-full p-3 pl-10 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/10 focus:border-[#0C4550] transition-all font-['Roboto',sans-serif]" />
//   </div>
// );

// const PasswordField = ({ show, onToggle, ...props }) => (
//   <div className="relative group">
//     <FaLock className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] group-focus-within:text-[#0C4550] transition-colors text-sm" />
//     <input type={show ? "text" : "password"} {...props} className="w-full p-3 pl-10 pr-10 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/10 focus:border-[#0C4550] transition-all font-['Roboto',sans-serif]" />
//     <button type="button" onClick={onToggle} className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] hover:text-[#0C4550] transition-colors text-sm">
//       {show ? <FaEyeSlash /> : <FaEye />}
//     </button>
//   </div>
// );

// export default Login;







// import React, { useState, useContext, useEffect, useMemo } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaEye,
//   FaEyeSlash,
//   FaEnvelope,
//   FaLock,
//   FaUser,
//   FaPhone,
//   FaBuilding,
//   FaCheckDouble,
//   FaArrowRight,
//   FaGlobe,
// } from "react-icons/fa";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { toast } from "react-toastify";

// // --- Background SMS Animation Component ---
// const BackgroundSMSAnimation = () => {
//   const messages = useMemo(() => Array.from({ length: 18 }).map((_, i) => ({
//     id: i,
//     left: Math.random() * 100,
//     duration: 15 + Math.random() * 15,
//     delay: Math.random() * 10,
//     scale: 0.6 + Math.random() * 0.6,
//     isUser: Math.random() > 0.5,
//     rotation: Math.random() * 10 - 5,
//   })), []);

//   return (
//     <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
//       {messages.map((msg) => (
//         <motion.div
//           key={msg.id}
//           className={`absolute w-64 p-4 rounded-2xl flex flex-col gap-2 backdrop-blur-[2px]
//             ${msg.isUser
//               ? "bg-[#C5F637]/10 border border-[#C5F637]/20 rounded-br-sm"
//               : "bg-white/10 border border-white/10 rounded-bl-sm"
//             }`}
//           initial={{ y: "110vh", opacity: 0 }}
//           animate={{
//             y: "-20vh",
//             opacity: [0, 0.4, 0.4, 0]
//           }}
//           transition={{
//             duration: msg.duration,
//             repeat: Infinity,
//             delay: msg.delay,
//             ease: "linear",
//           }}
//           style={{
//             left: `${msg.left}%`,
//             scale: msg.scale,
//             rotate: `${msg.rotation}deg`
//           }}
//         >
//           <div className={`h-2.5 rounded-full w-3/4 ${msg.isUser ? "bg-[#C5F637]/30" : "bg-white/30"}`} />
//           <div className={`h-2.5 rounded-full w-1/2 ${msg.isUser ? "bg-[#C5F637]/20" : "bg-white/20"}`} />
//           <div className="flex justify-end mt-1 opacity-60">
//             <FaCheckDouble className={`text-xs ${msg.isUser ? "text-[#C5F637]" : "text-white"}`} />
//           </div>
//         </motion.div>
//       ))}
//     </div>
//   );
// };

// const Login = () => {
//   const [user, setUser] = useState({ email: "", password: "" });
//   const [signupUser, setSignupUser] = useState({
//     Firstname: "",
//     Lastname: "",
//     email: "",
//     phone: "",
//     company: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [showSignupPassword, setShowSignupPassword] = useState(false);
//   const [showSignupConfirmPassword, setShowSignupConfirmPassword] = useState(false);
//   const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
//   const [signupMode, setSignupMode] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const [error, setError] = useState("");
//   const [currentSlogan, setCurrentSlogan] = useState(0);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { login } = useContext(AuthContext);

//   const slogans = [
//     { title: "Reach Millions Instantly", desc: "High-throughput Bulk SMS delivery engine." },
//     { title: "Engage. Convert. Grow.", desc: "SMS designed to increase customer impact." },
//     { title: "Global Connectivity", desc: "Direct operator connections across 200+ countries." },
//     { title: "Smart Routing API", desc: "Intelligent fallback logic for guaranteed delivery." },
//   ];

//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const mode = searchParams.get("mode");

//     if (mode === "signup") {
//       setSignupMode(true);
//       navigate("/login", { replace: true });
//     }
//   }, [location, navigate]);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlogan((prev) => (prev + 1) % slogans.length);
//     }, 4000);
//     return () => clearInterval(timer);
//   }, [slogans.length]);

//   const loginUser = async (email, password) => {
//     const response = await fetch(`${API_URL}/api/auth/login`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, password }),
//     });

//     const result = await response.json();
//     if (!response.ok || !result.success) {
//       throw new Error(result.message || "Login failed");
//     }
//     return result;
//   };

//   const goToHomePage = () => {
//     navigate("/");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       const response = await loginUser(user.email, user.password);
//       const token = response.data.token;

//       if (rememberMe) {
//         localStorage.setItem("email", user.email);
//         localStorage.setItem("rememberMe", "true");
//       } else {
//         localStorage.removeItem("email");
//         localStorage.removeItem("rememberMe");
//       }

//       localStorage.setItem("token", token);
//       login(token);

//       toast.success("Login successful!");

//       setTimeout(() => {
//         setLoading(false);
//         navigate("/dashboard");
//       }, 1000);

//     } catch (error) {
//       setError(error.message || "Login failed. Please check your credentials.");
//       setLoading(false);
//       toast.error(error.message);
//     }
//   };

//   const handleForgotPassword = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setTimeout(() => {
//       alert(`Password reset link sent to ${user.email}`);
//       setLoading(false);
//       setForgotPasswordMode(false);
//     }, 500);
//   };

//   // --- Regex Validation & Signup Logic ---
//   const handleSignupSubmit = async (e) => {
//     e.preventDefault();

//     // 1. Email Regex
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     // 2. Phone Regex (10 digits)
//     const phoneRegex = /^\d{10}$/;
//     // 3. Password Regex (min 8 chars, 1 uppercase, 1 special char, 1 number)
//     const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//     if (!emailRegex.test(signupUser.email)) {
//       toast.error("Please enter a valid email address.");
//       return;
//     }
//     if (!phoneRegex.test(signupUser.phone)) {
//       toast.error("Phone number must be exactly 10 digits.");
//       return;
//     }
//     if (!passwordRegex.test(signupUser.password)) {
//       toast.error("Password must be 8+ chars, with 1 Capital, 1 Number, and 1 Special symbol.");
//       return;
//     }
//     if (signupUser.password !== signupUser.confirmPassword) {
//       toast.error("Passwords do not match!");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await fetch(`${API_URL}/api/public/registrations`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           firstName: signupUser.Firstname,
//           lastName: signupUser.Lastname,
//           email: signupUser.email,
//           phone: signupUser.phone,
//           companyName: signupUser.company,
//           password: signupUser.password,
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok || !result.success) {
//         throw new Error(result.message || "Registration failed");
//       }

//       // Automatically clear columns on success
//       setSignupUser({
//         Firstname: "",
//         Lastname: "",
//         email: "",
//         phone: "",
//         company: "",
//         password: "",
//         confirmPassword: "",
//       });

//       toast.success(result.message || "Registration successful!");
      
//       setTimeout(() => {
//         setLoading(false);
//         setSignupMode(false);
//       }, 1500);

//     } catch (err) {
//       setError(err.message);
//       toast.error(err.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const savedEmail = localStorage.getItem("email");
//     const savedRememberMe = localStorage.getItem("rememberMe");

//     if (savedEmail && savedRememberMe) {
//       setUser((prev) => ({ ...prev, email: savedEmail }));
//       setRememberMe(true);
//     }
//   }, []);

//   return (
//     <div className="flex justify-center items-center min-h-screen bg-[#0C4550] relative overflow-hidden font-['Roboto',sans-serif]">
//       <style>
//         {`@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap');`}
//       </style>

//       <motion.button
//         onClick={goToHomePage}
//         className="absolute top-6 right-6 z-30 flex items-center gap-2 px-4 py-2.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-xl hover:bg-white/20 transition-all duration-300 group"
//         initial={{ opacity: 0, y: -10 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.5 }}
//         whileHover={{ scale: 1.05 }}
//         whileTap={{ scale: 0.95 }}
//       >
//         <FaGlobe className="text-sm" />
//         <span className="text-sm font-medium">Go to Website</span>
//         <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
//       </motion.button>

//       <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20 z-0"></div>
//       <BackgroundSMSAnimation />

//       <motion.div
//         className="relative z-20 w-full max-w-3xl mx-auto px-5 sm:px-6 md:px-10 lg:px-0 flex flex-col md:flex-row backdrop-blur-xl rounded-[20px] overflow-hidden md:border md:border-white/50 md:border-2"
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//       >
//         {/* Left side */}
//         <div className="hidden md:flex md:w-1/2 bg-[#083038] relative p-8 md:p-10 flex-col justify-between overflow-hidden">
//           <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 z-0"></div>

//           <div className="relative z-10">
//             <p className="text-3xl font-extrabold text-white mb-2 tracking-tight">
//               EURO<span className="text-[#C5F637]">FOX</span>
//             </p>
//             <p className="text-[#A7A08F] font-medium tracking-wide text-xs uppercase">Enterprise Communication</p>

//             <div className="mt-12 h-28 relative">
//               <AnimatePresence mode="wait">
//                 <motion.div
//                   key={currentSlogan}
//                   initial={{ opacity: 0, x: 20 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   exit={{ opacity: 0, x: -20 }}
//                   transition={{ duration: 0.5, ease: "easeInOut" }}
//                   className="absolute inset-0 flex flex-col justify-center"
//                 >
//                   <h3 className="text-2xl font-bold text-white leading-tight mb-2">
//                     {slogans[currentSlogan].title}
//                   </h3>
//                   <p className="text-gray-300 text-sm leading-relaxed border-l-3 border-[#C5F637] pl-3">
//                     {slogans[currentSlogan].desc}
//                   </p>
//                 </motion.div>
//               </AnimatePresence>
//             </div>

//             <div className="flex gap-2 mt-6">
//               {slogans.map((_, index) => (
//                 <div
//                   key={index}
//                   className={`h-1 rounded-full transition-all duration-300 ${index === currentSlogan ? "w-6 bg-[#C5F637]" : "w-2 bg-white/20"}`}
//                 ></div>
//               ))}
//             </div>
//           </div>

//           <div className="relative z-10">
//             <p className="text-white/40 text-xs mt-4">Trusted by 10,000+ Enterprises Worldwide</p>
//           </div>
//           <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-[#C5F637] rounded-full opacity-10 blur-2xl"></div>
//         </div>

//         {/* Right Side: Form */}
//         <div className="w-full md:w-1/2 px-5 py-5 md:p-10 bg-white flex md:rounded-[1px] rounded-[10px] flex-col justify-center">
//           <div className="text-left mb-6">
//             <p className="text-2xl font-bold text-[#0C4550] mb-2">
//               {signupMode ? "Create Account" : forgotPasswordMode ? "Reset Password" : "Welcome Back"}
//             </p>
//             <p className="text-gray-700 text-sm">
//               {signupMode ? "Start your 14-day free trial" : forgotPasswordMode ? "We'll email you instructions" : "Please enter your details to sign in"}
//             </p>
//           </div>

//           {error && !signupMode && (
//             <div className="mb-5 p-3 bg-red-50 border border-red-100 text-red-600 rounded-lg text-sm flex items-center gap-2 animate-pulse">
//               <div className="w-1.5 h-1.5 bg-red-500 rounded-full"></div>
//               {error}
//             </div>
//           )}

//           <form onSubmit={signupMode ? handleSignupSubmit : forgotPasswordMode ? handleForgotPassword : handleSubmit}>
//             {signupMode ? (
//               <div className="grid grid-cols-2 gap-3">
//                 <InputField icon={FaUser} type="text" placeholder="First Name" value={signupUser.Firstname} onChange={(e) => setSignupUser({ ...signupUser, Firstname: e.target.value })} required />
//                 <InputField icon={FaUser} type="text" placeholder="Last Name" value={signupUser.Lastname} onChange={(e) => setSignupUser({ ...signupUser, Lastname: e.target.value })} />
//                 <InputField icon={FaEnvelope} type="email" placeholder="Email" className="col-span-2" value={signupUser.email} onChange={(e) => setSignupUser({ ...signupUser, email: e.target.value })} required />
//                 <InputField icon={FaPhone} type="text" placeholder="Phone" value={signupUser.phone} onChange={(e) => setSignupUser({ ...signupUser, phone: e.target.value })} required />
//                 <InputField icon={FaBuilding} type="text" placeholder="Company" value={signupUser.company} onChange={(e) => setSignupUser({ ...signupUser, company: e.target.value })} />
//                 <PasswordField placeholder="Password" value={signupUser.password} onChange={(e) => setSignupUser({ ...signupUser, password: e.target.value })} show={showSignupPassword} onToggle={() => setShowSignupPassword(!showSignupPassword)} required />
//                 <PasswordField placeholder="Confirm" value={signupUser.confirmPassword} onChange={(e) => setSignupUser({ ...signupUser, confirmPassword: e.target.value })} show={showSignupConfirmPassword} onToggle={() => setShowSignupConfirmPassword(!showSignupConfirmPassword)} required />
//               </div>
//             ) : (
//               <div className="space-y-4">
//                 <InputField icon={FaEnvelope} type="email" placeholder="Email Address" value={user.email} onChange={(e) => setUser({ ...user, email: e.target.value })} required />
//                 {!forgotPasswordMode && (
//                   <PasswordField placeholder="Password" value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} show={showPassword} onToggle={() => setShowPassword(!showPassword)} required />
//                 )}
//               </div>
//             )}

//             {!forgotPasswordMode && !signupMode && (
//               <div className="flex items-center justify-between mt-4">
//                 <label className="flex items-center text-sm text-gray-800 font-base cursor-pointer transition-colors">
//                   <input type="checkbox" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} className="mr-2 accent-[#0C4550]" />
//                   Remember me
//                 </label>
//                 <button type="button" className="text-sm font-base text-gray-800 transition-colors" onClick={() => setForgotPasswordMode(true)}>
//                   Forgot password?
//                 </button>
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full mt-6 py-3 bg-[#0C4550] text-white rounded-xl font-bold shadow-lg shadow-[#0C4550]/20 hover:bg-[#09353e] transition-all duration-300 transform hover:-translate-y-0.5 active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center gap-2"
//             >
//               {loading ? (
//                 <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
//               ) : (
//                 signupMode ? "Create Account" : forgotPasswordMode ? "Send Reset Link" : "Sign In"
//               )}
//             </button>
//           </form>

//           <div className="mt-6 text-center text-sm">
//             {forgotPasswordMode ? (
//               <p className="text-gray-700">Remembered? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setForgotPasswordMode(false)}>Login</button></p>
//             ) : !signupMode ? (
//               <p className="text-gray-700">Don't have an account? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setSignupMode(true)}>Sign up</button></p>
//             ) : (
//               <p className="text-gray-700">Already have an account? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setSignupMode(false)}>Login</button></p>
//             )}
//           </div>

//           <div className="mt-5 pt-5 border-t border-gray-100">
//             <button
//               onClick={goToHomePage}
//               className="w-full flex items-center justify-center gap-2 py-2.5 text-gray-800 font-medium hover:bg-gray-50 rounded-lg transition-all group"
//             >
//               <span className="text-sm">Explore Our Website</span>
//               <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
//             </button>
//           </div>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// const InputField = ({ icon: Icon, className = "", ...props }) => (
//   <div className={`relative group ${className}`}>
//     <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] group-focus-within:text-[#0C4550] transition-colors text-sm" />
//     <input {...props} className="w-full p-3 pl-10 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/10 focus:border-[#0C4550] transition-all font-['Roboto',sans-serif]" />
//   </div>
// );

// const PasswordField = ({ show, onToggle, ...props }) => (
//   <div className="relative group">
//     <FaLock className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] group-focus-within:text-[#0C4550] transition-colors text-sm" />
//     <input type={show ? "text" : "password"} {...props} className="w-full p-3 pl-10 pr-10 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/10 focus:border-[#0C4550] transition-all font-['Roboto',sans-serif]" />
//     <button type="button" onClick={onToggle} className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] hover:text-[#0C4550] transition-colors text-sm">
//       {show ? <FaEyeSlash /> : <FaEye />}
//     </button>
//   </div>
// );

// export default Login;





import React, { useState, useContext, useEffect, useMemo } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaEye,
  FaEyeSlash,
  FaEnvelope,
  FaLock,
  FaUser,
  FaPhone,
  FaBuilding,
  FaCheckDouble,
  FaArrowRight,
  FaGlobe,
} from "react-icons/fa";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";

// --- Background SMS Animation Component ---
const BackgroundSMSAnimation = () => {
  const messages = useMemo(() => Array.from({ length: 18 }).map((_, i) => ({
    id: i,
    left: Math.random() * 100,
    duration: 15 + Math.random() * 15,
    delay: Math.random() * 10,
    scale: 0.6 + Math.random() * 0.6,
    isUser: Math.random() > 0.5,
    rotation: Math.random() * 10 - 5,
  })), []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {messages.map((msg) => (
        <motion.div
          key={msg.id}
          className={`absolute w-64 p-4 rounded-2xl flex flex-col gap-2 backdrop-blur-[2px]
            ${msg.isUser
              ? "bg-[#C5F637]/10 border border-[#C5F637]/20 rounded-br-sm"
              : "bg-white/10 border border-white/10 rounded-bl-sm"
            }`}
          initial={{ y: "110vh", opacity: 0 }}
          animate={{
            y: "-20vh",
            opacity: [0, 0.4, 0.4, 0]
          }}
          transition={{
            duration: msg.duration,
            repeat: Infinity,
            delay: msg.delay,
            ease: "linear",
          }}
          style={{
            left: `${msg.left}%`,
            scale: msg.scale,
            rotate: `${msg.rotation}deg`
          }}
        >
          <div className={`h-2.5 rounded-full w-3/4 ${msg.isUser ? "bg-[#C5F637]/30" : "bg-white/30"}`} />
          <div className={`h-2.5 rounded-full w-1/2 ${msg.isUser ? "bg-[#C5F637]/20" : "bg-white/20"}`} />
          <div className="flex justify-end mt-1 opacity-60">
            <FaCheckDouble className={`text-xs ${msg.isUser ? "text-[#C5F637]" : "text-white"}`} />
          </div>
        </motion.div>
      ))}
    </div>
  );
};

const Login = () => {
  const [user, setUser] = useState({ email: "", password: "" });
  const [signupUser, setSignupUser] = useState({
    Firstname: "",
    Lastname: "",
    email: "",
    phone: "",
    company: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showSignupPassword, setShowSignupPassword] = useState(false);
  const [showSignupConfirmPassword, setShowSignupConfirmPassword] = useState(false);
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [signupMode, setSignupMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [currentSlogan, setCurrentSlogan] = useState(0);

  // --- NEW: OTP Flow States ---
  const [otpMode, setOtpMode] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useContext(AuthContext);

  const slogans = [
    { title: "Reach Millions Instantly", desc: "High-throughput Bulk SMS delivery engine." },
    { title: "Engage. Convert. Grow.", desc: "SMS designed to increase customer impact." },
    { title: "Global Connectivity", desc: "Direct operator connections across 200+ countries." },
    { title: "Smart Routing API", desc: "Intelligent fallback logic for guaranteed delivery." },
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const mode = searchParams.get("mode");

    if (mode === "signup") {
      setSignupMode(true);
      navigate("/login", { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlogan((prev) => (prev + 1) % slogans.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slogans.length]);

  const loginUser = async (email, password) => {
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error(result.message || "Login failed");
    }
    return result;
  };

  const goToHomePage = () => {
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await loginUser(user.email, user.password);
      const token = response.data.token;

      if (rememberMe) {
        localStorage.setItem("email", user.email);
        localStorage.setItem("rememberMe", "true");
      } else {
        localStorage.removeItem("email");
        localStorage.removeItem("rememberMe");
      }

      localStorage.setItem("token", token);
      login(token);

      toast.success("Login successful!");

      setTimeout(() => {
        setLoading(false);
        navigate("/dashboard");
      }, 1000);

    } catch (error) {
      setError(error.message || "Login failed. Please check your credentials.");
      setLoading(false);
      toast.error(error.message);
    }
  };

  // --- UPDATED: Screen 1 — Request OTP ---
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${API_URL}/api/auth/password/request-otp?email=${encodeURIComponent(user.email)}`,
        { method: "POST" }
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Failed to send OTP");
      }

      toast.success(result.message || "OTP sent successfully to email");
      setOtpMode(true);
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- NEW: Screen 2 — Verify OTP & Reset Password ---
  const handleResetPassword = async (e) => {
    e.preventDefault();

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!passwordRegex.test(newPassword)) {
      toast.error("Password must be 8+ chars, with 1 Capital, 1 Number, and 1 Special symbol.");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_URL}/api/auth/password/reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: user.email, otp, newPassword }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Password reset failed");
      }

      toast.success(result.message || "Password changed successfully!");

      setTimeout(() => {
        setLoading(false);
        setForgotPasswordMode(false);
        setOtpMode(false);
        setOtp("");
        setNewPassword("");
        setConfirmNewPassword("");
      }, 1500);
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
      setLoading(false);
    }
  };

  // --- Regex Validation & Signup Logic ---
  const handleSignupSubmit = async (e) => {
    e.preventDefault();

    // 1. Email Regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // 2. Phone Regex (10 digits)
    const phoneRegex = /^\d{10}$/;
    // 3. Password Regex (min 8 chars, 1 uppercase, 1 special char, 1 number)
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!emailRegex.test(signupUser.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (!phoneRegex.test(signupUser.phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }
    if (!passwordRegex.test(signupUser.password)) {
      toast.error("Password must be 8+ chars, with 1 Capital, 1 Number, and 1 Special symbol.");
      return;
    }
    if (signupUser.password !== signupUser.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_URL}/api/public/registrations`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName: signupUser.Firstname,
          lastName: signupUser.Lastname,
          email: signupUser.email,
          phone: signupUser.phone,
          companyName: signupUser.company,
          password: signupUser.password,
        }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Registration failed");
      }

      // Automatically clear columns on success
      setSignupUser({
        Firstname: "",
        Lastname: "",
        email: "",
        phone: "",
        company: "",
        password: "",
        confirmPassword: "",
      });

      toast.success(result.message || "Registration successful!");
      
      setTimeout(() => {
        setLoading(false);
        setSignupMode(false);
      }, 1500);

    } catch (err) {
      setError(err.message);
      toast.error(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    const savedRememberMe = localStorage.getItem("rememberMe");

    if (savedEmail && savedRememberMe) {
      setUser((prev) => ({ ...prev, email: savedEmail }));
      setRememberMe(true);
    }
  }, []);

  return (
    <div className="flex justify-center items-center min-h-screen bg-[#0C4550] relative overflow-hidden font-['Roboto',sans-serif]">
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap');`}
      </style>

      <motion.button
        onClick={goToHomePage}
        className="absolute top-6 right-6 z-30 flex items-center gap-2 px-4 py-2.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-xl hover:bg-white/20 transition-all duration-300 group"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaGlobe className="text-sm" />
        <span className="text-sm font-medium">Go to Website</span>
        <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
      </motion.button>

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20 z-0"></div>
      <BackgroundSMSAnimation />

      <motion.div
        className="relative z-20 w-full max-w-3xl mx-auto px-5 sm:px-6 md:px-10 lg:px-0 flex flex-col md:flex-row backdrop-blur-xl rounded-[20px] overflow-hidden md:border md:border-white/50 md:border-2"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Left side */}
        <div className="hidden md:flex md:w-1/2 bg-[#083038] relative p-8 md:p-10 flex-col justify-between overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 z-0"></div>

          <div className="relative z-10">
            <p className="text-3xl font-extrabold text-white mb-2 tracking-tight">
              EURO<span className="text-[#C5F637]">FOX</span>
            </p>
            <p className="text-[#A7A08F] font-medium tracking-wide text-xs uppercase">Enterprise Communication</p>

            <div className="mt-12 h-28 relative">
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentSlogan}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="absolute inset-0 flex flex-col justify-center"
                >
                  <h3 className="text-2xl font-bold text-white leading-tight mb-2">
                    {slogans[currentSlogan].title}
                  </h3>
                  <p className="text-gray-300 text-sm leading-relaxed border-l-3 border-[#C5F637] pl-3">
                    {slogans[currentSlogan].desc}
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>

            <div className="flex gap-2 mt-6">
              {slogans.map((_, index) => (
                <div
                  key={index}
                  className={`h-1 rounded-full transition-all duration-300 ${index === currentSlogan ? "w-6 bg-[#C5F637]" : "w-2 bg-white/20"}`}
                ></div>
              ))}
            </div>
          </div>

          <div className="relative z-10">
            <p className="text-white/40 text-xs mt-4">Trusted by 10,000+ Enterprises Worldwide</p>
          </div>
          <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-[#C5F637] rounded-full opacity-10 blur-2xl"></div>
        </div>

        {/* Right Side: Form */}
        <div className="w-full md:w-1/2 px-5 py-5 md:p-10 bg-white flex md:rounded-[1px] rounded-[10px] flex-col justify-center">
          <div className="text-left mb-6">
            <p className="text-2xl font-bold text-[#0C4550] mb-2">
              {signupMode ? "Create Account" : forgotPasswordMode ? (otpMode ? "Verify OTP" : "Reset Password") : "Welcome Back"}
            </p>
            <p className="text-gray-700 text-sm">
              {signupMode
                ? "Start your 14-day free trial"
                : forgotPasswordMode
                ? otpMode
                  ? `Enter the OTP sent to ${user.email}`
                  : "We'll email you instructions"
                : "Please enter your details to sign in"}
            </p>
          </div>

          {error && !signupMode && (
            <div className="mb-5 p-3 bg-red-50 border border-red-100 text-red-600 rounded-lg text-sm flex items-center gap-2 animate-pulse">
              <div className="w-1.5 h-1.5 bg-red-500 rounded-full"></div>
              {error}
            </div>
          )}

          <form onSubmit={signupMode ? handleSignupSubmit : forgotPasswordMode ? (otpMode ? handleResetPassword : handleForgotPassword) : handleSubmit}>
            {signupMode ? (
              <div className="grid grid-cols-2 gap-3">
                <InputField icon={FaUser} type="text" placeholder="First Name" value={signupUser.Firstname} onChange={(e) => setSignupUser({ ...signupUser, Firstname: e.target.value })} required />
                <InputField icon={FaUser} type="text" placeholder="Last Name" value={signupUser.Lastname} onChange={(e) => setSignupUser({ ...signupUser, Lastname: e.target.value })} />
                <InputField icon={FaEnvelope} type="email" placeholder="Email" className="col-span-2" value={signupUser.email} onChange={(e) => setSignupUser({ ...signupUser, email: e.target.value })} required />
                <InputField icon={FaPhone} type="text" placeholder="Phone" value={signupUser.phone} onChange={(e) => setSignupUser({ ...signupUser, phone: e.target.value })} required />
                <InputField icon={FaBuilding} type="text" placeholder="Company" value={signupUser.company} onChange={(e) => setSignupUser({ ...signupUser, company: e.target.value })} />
                <PasswordField placeholder="Password" value={signupUser.password} onChange={(e) => setSignupUser({ ...signupUser, password: e.target.value })} show={showSignupPassword} onToggle={() => setShowSignupPassword(!showSignupPassword)} required />
                <PasswordField placeholder="Confirm" value={signupUser.confirmPassword} onChange={(e) => setSignupUser({ ...signupUser, confirmPassword: e.target.value })} show={showSignupConfirmPassword} onToggle={() => setShowSignupConfirmPassword(!showSignupConfirmPassword)} required />
              </div>
            ) : forgotPasswordMode && otpMode ? (
              /* --- Screen 2: OTP + New Password --- */
              <div className="space-y-4">
                <InputField icon={FaLock} type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} required />
                <PasswordField placeholder="New Password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} show={showNewPassword} onToggle={() => setShowNewPassword(!showNewPassword)} required />
                <PasswordField placeholder="Confirm New Password" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} show={showConfirmNewPassword} onToggle={() => setShowConfirmNewPassword(!showConfirmNewPassword)} required />
              </div>
            ) : (
              <div className="space-y-4">
                <InputField icon={FaEnvelope} type="email" placeholder="Email Address" value={user.email} onChange={(e) => setUser({ ...user, email: e.target.value })} required />
                {!forgotPasswordMode && (
                  <PasswordField placeholder="Password" value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} show={showPassword} onToggle={() => setShowPassword(!showPassword)} required />
                )}
              </div>
            )}

            {!forgotPasswordMode && !signupMode && (
              <div className="flex items-center justify-between mt-4">
                <label className="flex items-center text-sm text-gray-800 font-base cursor-pointer transition-colors">
                  <input type="checkbox" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} className="mr-2 accent-[#0C4550]" />
                  Remember me
                </label>
                <button type="button" className="text-sm font-base text-gray-800 transition-colors" onClick={() => setForgotPasswordMode(true)}>
                  Forgot password?
                </button>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-6 py-3 bg-[#0C4550] text-white rounded-xl font-bold shadow-lg shadow-[#0C4550]/20 hover:bg-[#09353e] transition-all duration-300 transform hover:-translate-y-0.5 active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center gap-2"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
              ) : (
                signupMode ? "Create Account" : forgotPasswordMode ? (otpMode ? "Reset Password" : "Send Reset Link") : "Sign In"
              )}
            </button>
          </form>

          <div className="mt-6 text-center text-sm">
            {forgotPasswordMode ? (
              <p className="text-gray-700">
                Remembered?{" "}
                <button
                  className="font-bold text-[#0C4550] hover:underline"
                  onClick={() => {
                    setForgotPasswordMode(false);
                    setOtpMode(false);
                    setOtp("");
                    setNewPassword("");
                    setConfirmNewPassword("");
                  }}
                >
                  Login
                </button>
              </p>
            ) : !signupMode ? (
              <p className="text-gray-700">Don't have an account? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setSignupMode(true)}>Sign up</button></p>
            ) : (
              <p className="text-gray-700">Already have an account? <button className="font-bold text-[#0C4550] hover:underline" onClick={() => setSignupMode(false)}>Login</button></p>
            )}
          </div>

          <div className="mt-5 pt-5 border-t border-gray-100">
            <button
              onClick={goToHomePage}
              className="w-full flex items-center justify-center gap-2 py-2.5 text-gray-800 font-medium hover:bg-gray-50 rounded-lg transition-all group"
            >
              <span className="text-sm">Explore Our Website</span>
              <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

const InputField = ({ icon: Icon, className = "", ...props }) => (
  <div className={`relative group ${className}`}>
    <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] group-focus-within:text-[#0C4550] transition-colors text-sm" />
    <input {...props} className="w-full p-3 pl-10 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/10 focus:border-[#0C4550] transition-all font-['Roboto',sans-serif]" />
  </div>
);

const PasswordField = ({ show, onToggle, ...props }) => (
  <div className="relative group">
    <FaLock className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] group-focus-within:text-[#0C4550] transition-colors text-sm" />
    <input type={show ? "text" : "password"} {...props} className="w-full p-3 pl-10 pr-10 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/10 focus:border-[#0C4550] transition-all font-['Roboto',sans-serif]" />
    <button type="button" onClick={onToggle} className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#A7A08F] hover:text-[#0C4550] transition-colors text-sm">
      {show ? <FaEyeSlash /> : <FaEye />}
    </button>
  </div>
);

export default Login;